// import { FaUserMd, FaHospitalUser, FaClipboardCheck, FaChartLine, FaShieldAlt, FaExchangeAlt, FaIdCard, FaFileInvoiceDollar, FaBars, FaRegWindowClose, FaFileAlt, FaBuilding, FaUserPlus, FaCreditCard, FaHospital, FaUsers, FaAmbulance, FaCrosshairs, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import {FaBars,FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import { PiSpeedometerBold } from 'react-icons/pi'
// import { LiaClipboardListSolid } from "react-icons/lia";
// import { RiCoinsLine, RiHandCoinLine } from "react-icons/ri";
import { RiCloseLargeFill } from "react-icons/ri";
// import onboardingHandshake from "../../assets/icons_services_onboarding/handshake-gray 1.svg";
// import onboardingEnrollment from "../../assets/icons_services_onboarding/Payor-Enrollment-Gray.svg";
// import onboardingMonitoring from "../../assets/icons_services_onboarding/Monitering-and-Tracking-Gray.svg";
// import onboardingCredentialing from "../../assets/icons_services_onboarding/provider-credentialing-gray 1.svg";
// import Data_Manage from "../../assets/icons_services_onboarding/data-management.svg";
// import Security_Risk from "../../assets/icons_services_onboarding/security-audit.svg";
// import Vendor_Cred from "../../assets/icons_services_onboarding/id-card.svg";
 
const ServiceIcon = ({ type, size = 30, color = "#333" }) => {
  const icons = {
    // "credentialing-icon": onboardingCredentialing,
    // "onboarding-icon":onboardingHandshake,
    // "monitoring-icon": onboardingMonitoring,
    // "vendor-icon": Vendor_Cred,
    // "security-icon": Security_Risk,
    // "data-icon": Data_Manage,
    // "payor-icon": onboardingEnrollment,
 
    // //Alt-Icons
    // /// Was being used in getServiceIcon in Header.jsx for Services
    // "credentialing-icon-alt": onboardingCredentialing,
    // "vendor-icon-alt": Vendor_Cred,
    // "onboarding-icon-alt": onboardingHandshake,
    // "payor-icon-alt": onboardingEnrollment,
 
    // Icons clientTypes
    // "healthcare-professionals-icon": <FaUserMd size={size} color={color} />,
    // "health-plans-icon": <FaFileAlt size={size} color={color} />,
    // "healthcare-facilities-icon": <FaHospital size={size} color={color} />,
    // "healthcare-vendors-icon": <FaAmbulance size={size} color={color} />,
    // "support-services-icon":<FaHospitalUser size={size} color={color} />,
    // "others-icon": <FaUsers size={size} color={color} />,
 
    // Icons Mobile Nav
    "open-mobile-menu-icon": <FaBars size={size} color={color} />,
    "close-mobile-menu-icon": <RiCloseLargeFill size={size} color={color} />,
    "down-arrow-menu-icon": <FaChevronDown size={size} color={color} />,    
    "up-arrow-menu-icon": <FaChevronUp size={size} color={color} />,    
  };
 
  return icons[type] || null;
};
 
export default ServiceIcon;
 